import React from "react";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Category, ExitToApp, LibraryMusic, People, Audiotrack, Archive } from "@material-ui/icons";
import { paths } from "frontend/src/pages/paths";
import { logout } from "frontend/src/features/session";
import { useViewerRoles } from "frontend/src/domain/session";
var Item = function (_a) {
    var url = _a.url, name = _a.name, icon = _a.icon;
    var match = useRouteMatch(url);
    return (React.createElement(ListItem, { button: true, selected: Boolean(match), component: Link, to: url },
        React.createElement(ListItemIcon, null, icon),
        React.createElement(ListItemText, { primary: name })));
};
export var Navigation = function () {
    var onExit = function () { return logout(); };
    var admin = useViewerRoles().admin;
    return (React.createElement(List, null,
        React.createElement(Item, { name: "Треки", url: paths.admin.tracks.index(), icon: React.createElement(Audiotrack, null) }),
        React.createElement(Item, { name: "Плейлисты", url: paths.admin.playlists.index(), icon: React.createElement(LibraryMusic, null) }),
        React.createElement(Item, { name: "Архивы музыки", url: paths.admin.musicArchives.index(), icon: React.createElement(Archive, null) }),
        React.createElement(Item, { name: "Категории плейлистов", url: paths.admin.playlistsBusinessTypes.viewAny(), icon: React.createElement(Category, null) }),
        admin && (React.createElement(Item, { name: "Клиенты", url: paths.admin.clients.index(), icon: React.createElement(People, null) })),
        React.createElement(ListItem, { button: true, onClick: onExit },
            React.createElement(ListItemIcon, null,
                React.createElement(ExitToApp, null)),
            React.createElement(ListItemText, { primary: "Выход" }))));
};
